<template>
  <div class="normal1" style="background: #f2f3f5; padding-bottom: 100px;" v-loading.fullscreen.lock="!consule.id">
<!--    <div class="carousel">
      <video autoplay muted loop preload="auto" style="z-index: 200; width: 100%; height: auto">
        &lt;!&ndash; <source type="video/mp4" src="@/assets/images/banner.mp4" /> &ndash;&gt;
      </video>
    </div>-->

    <div style="display: flex;  justify-content: center;">
      <div style="width: 1280px; margin-top:60px;box-shadow: rgb(0 0 0 / 5%) 0px 1px 1px 0px;">
        <div class="contentWrap">
          <div class="btnWrap">
            <div v-if="downloadEnabled === 0" class="btn" @click="downloadDialogShow = true">下载
            </div>
            <div v-if="feedbackEnabled === 0" class="btn" @click="feedbackDialogShow = true">意见反馈
            </div>
          </div>
          <div style="border-bottom: 1px solid #53515124; padding-bottom: 20px;margin-bottom: 20px;">
            <!-- <p> {{ title | titleFilter }} > {{ name | nameFilter }}</p> -->
          <div style="margin-left: 30px;">
            <p style="font-weight: 600;"> <span style="color: #999;cursor: pointer;" @click="handleBacksy">首页</span> <span style="color: #999;">></span> <span style="color: #000;cursor: pointer;" @click="handleBackptzx">平台资讯</span></p>
            <h2 style="margin-top: 20px;font-weight: 800;" >{{consule.title}}</h2>
            <p>{{consule.createTime}}</p>
          </div>
            <!-- <p>{{consule.createTime.substring(0,11)}}</p> -->
          </div>
          <mavon-editor style="border: none;background: white;" :xssOptions="false" :value="content" :subfield="false" :defaultOpen="'preview'" :toolbarsFlag="false"
            :editable="false" :scrollStyle="true" :ishljs="true" :boxShadow="true" :toolbars="{}">
          </mavon-editor>
        </div>

      </div>
    </div>

    <div class="qtzx">
      <h1>其他资讯</h1>
      <ul>
        <li v-for="item in consuleList" :key="item.id" @click="handleDetailsClick(item)">
          <div>
              <span class="point"></span>
          </div>
          <div  style=" overflow: hidden;">
            <h4>{{item.title}}</h4>
            <span>{{item.createTime}}</span>
          </div>
        </li>
      </ul>
    </div>
    <el-dialog title="下载" :visible.sync="downloadDialogShow" @closed="downloadCancel">
      <el-form :model="downloadForm" :rules="downloadRules" ref="downloadForm">
        <el-form-item label="下载单位" :label-width="formLabelWidth" prop="companyName">
          <el-input v-model="downloadForm.companyName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="下载目的" :label-width="formLabelWidth" prop="purpose">
          <el-select v-model="downloadForm.purpose" placeholder="请选择">
            <el-option label="指导平台建设" value="指导平台建设"></el-option>
            <el-option label="获取行业现状" value="获取行业现状"></el-option>
            <el-option label="了解公司业务" value="了解公司业务"></el-option>
            <el-option label="个人学习" value="个人学习"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="下载人" :label-width="formLabelWidth" prop="operUsername">
          <el-input v-model="downloadForm.operUsername" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" :label-width="formLabelWidth" prop="contactNo">
          <el-input v-model="downloadForm.contactNo" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="downloadCancel">取 消</el-button>
        <el-button type="primary" @click="downloadSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="意见反馈" :visible.sync="feedbackDialogShow" @closed="feedbackCancel">
      <el-form :model="feedbackForm" :rules="feedbackRules" ref="feedbackForm">
        <el-form-item label="反馈内容" :label-width="formLabelWidth" prop="feedback">
          <el-input type="textarea" v-model="feedbackForm.feedback" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="反馈人" :label-width="formLabelWidth" prop="operUsername">
          <el-input v-model="feedbackForm.operUsername" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" :label-width="formLabelWidth" prop='contactNo'>
          <el-input v-model="feedbackForm.contactNo" autocomplete="off"></el-input>
        </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="feedbackCancel">取 消</el-button>
        <el-button type="primary" @click="feedbackSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <div v-if="showButton" class="to-top" @click="totop()">
      <img src="../../assets/images/totop.png" alt="" />
    </div>
  </div>
</template>

<script>
import { getConsultInfo, saveOperLog, downloadFile, } from '@/api/consult'
import { detailArticle } from '@/api/console'
import { async } from 'q'
import { getConsultList } from '@/api/consult'

export default {
  name: 'ConsultDetails',
  filters: {
    nameFilter(val) {
      switch (val) {
        case 'PT_CONSULT':
          return '资讯详情';
        case 'PT_NEWS':
          return '新闻详情';
        case 'CO_NOTICE':
          return '公告详情';
        case 'CO_RULES':
          return '制度详情';
        case 'PT_POLICY':
          return '政策详情';
      }
    },
    titleFilter(val) {
      switch (val) {
        case 'CO_NOTICE':
          return '通知公告';
        case 'CO_RULES':
          return '制度规范';
        case 'PT_POLICY':
          return '行业政策';
        default:
          return '平台资讯';
      }
    },
  },
  data() {
    return {
        // 返回顶部按钮
        showButton: false,
      consuleList: [],
      name: undefined,
      content: undefined,
      downloadDialogShow: false,
      feedbackDialogShow: false,
      downloadForm: {
        companyName: '',
        purpose: '',
        operUsername: '',
        contactNo: ''
      },
      feedbackForm: {
        feedback: '',
        operUsername: '',
        contactNo: ''

      },
      formLabelWidth: '120px',
      feedbackRules: {
        feedback: { required: true, message: '请输入联系方式', trigger: 'blur' },
        operUsername: { required: true, message: '请输入反馈人', trigger: 'blur' },
        contactNo: [{
          required: true,
          message: '请输入联系方式',
          trigger: 'blur'
        }, {
          pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
          message: '请输入正确的手机号',
          trigger: 'blur'
        }],
      },

      downloadRules: {
        companyName: { required: true, message: '请输入下载单位', trigger: 'blur' },
        purpose: { required: true, message: '请输入下载目的', trigger: 'blur' },
        operUsername: { required: true, message: '请输入下载人', trigger: 'blur' },
        contactNo: [{
          required: true,
          message: '请输入联系方式',
          trigger: 'blur'
        }, {
          pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
          message: '请输入正确的手机号',
          trigger: 'blur'
        }],
      },
      downloadEnabled: 1,
      feedbackEnabled: 1,
      fileUrl: '',
      consule: {
        
      },
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    getConsultList({
      pageNum:1,
      pageSize:6,
      articleType: "PT_CONSULT"
    }).then(res => {
      this.consuleList = res.rows
    })

    this.name = this.$route.query.name
    this.title = this.$route.query.title
    if (this.$route.query.type === null || !this.$route.query.type) {
      getConsultInfo(this.$route.query.id).then(res => {
        this.content = res.data.content
        this.downloadEnabled = res.data.downloadEnabled
        this.feedbackEnabled = res.data.feedbackEnabled
        this.fileUrl = res.data.fileUrl
        this.consule = res.data
      })
    } else {
      detailArticle({ "id": this.$route.query.id }).then(res => {
        this.content = res.data.content
        this.downloadEnabled = res.data.isDownloadEnabled
        this.feedbackEnabled = res.data.isFeedbackEnabled
        this.fileUrl = res.data.fileUrl
        this.consule = res.data
      })
    }
  },
  methods: {
    handleScroll() {
      this.showButton = window.scrollY > 200;
    },
    totop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth", // 使滚动效果平滑
      });
    },
    handleBacksy(){
      window.location.href = "/"
    },
    handleBackptzx(){
      window.location.href = "/Information"
    },
    handleDetailsClick (item) {
      window.open("/ConsultDetails?id="+item.id)
    },
    downloadSubmit() {
      this.$refs['downloadForm'].validate(async (valid) => {
        if (valid) {

          // 提交
          const data = { ...this.downloadForm, operType: 1, isSendMail: 1, articleId: this.$route.query.id }

          const res = await saveOperLog(data)
          // 下载
          const bucketName = this.fileUrl.split('/')[this.fileUrl.split('/').length - 2]
          const key = this.fileUrl.split('/')[this.fileUrl.split('/').length - 1]
          window.open('https://www.eiiplat.com/api/jz/file/download/' + bucketName + '/' + key)
          // await downloadFile(bucketName, key)
          this.downloadCancel()
        } else {
          return false;
        }
      });
    },
    downloadCancel() {
      this.downloadDialogShow = false
      this.$refs['downloadForm'].resetFields()
    },
    feedbackSubmit() {
      this.$refs['feedbackForm'].validate(async (valid) => {
        if (valid) {
          const data = { ...this.feedbackForm, operType: 2, isSendMail: 1, articleId: this.$route.query.id }
          // 提交
          await saveOperLog(data)
          this.feedbackCancel()
        } else {
          return false;
        }
      });
    },
    feedbackCancel() {
      this.feedbackDialogShow = false
      this.$refs['feedbackForm'].resetFields()
    }
  },
}
</script>
<style lang="scss" scoped>
.to-top {
  cursor: pointer;
  width: 50px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  border-radius: 5px;
  // border: 1px solid #ccc;
  position: fixed;
  z-index: 9999999;
  bottom: 100px;
  right: 100px;
  background-color: #fff;
  box-shadow: 0px 0px 8px 2px #ccc;
  img {
    width: 50%;
    height: 50%;
  }
}
>>> .markdown-body h6{
  text-align: left;
  color: var(---999, #999);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px; /* 228.571% */
}
.normal1 {
  min-height: 800px;
}
.el-select {
  width: 100%;
}

.contentWrap {
  position: relative;
  margin-top: 40px;
  background: white;
  // box-shadow: rgb(0 0 0 / 5%) 0px 1px 1px 0px;
  padding: 50px;

  .btnWrap {
    position: absolute;
    top: 0.1rem;
    right: 0.2rem;
    display: flex;
    z-index: 1501;
    font-size: 0.18rem;
    color: rgb(102, 101, 101);

    .btn {
      margin-right: 0.2rem;
      cursor: pointer;
    }
  }
}

.qtzx {
  text-align: center;
  margin-top: 50px;
  ul {
    max-width: 1280px;
    background: white;
    list-style-type: none;
    padding-left: 0px;
    margin: 0 auto;
    padding: 20px;
    display: flex; /* 使用Flex布局 */
    flex-wrap: wrap;
    li {
      width: 50%;
      text-align: left;
      padding-left: 70px;
      margin: 13px 0px;
      display: flex;
      cursor: pointer;
      h4 {
        color: black;
        font-weight: 700;
        font-size: 16px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .point {
        color: darkgray;
        border-radius: 10px;
        background: #a9a9a99c;
        display: inline-block;
        width: 10px;
        height: 10px;
        margin-right: 10px;
      }
    }
  }
}
</style>

<style>
.v-show-content {
  background: white !important;
}
.markdown-body {
  border: none !important;
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ConsultDetails/index.vue